<template>
	<div class="BaseReportGraph pb-8">
		<div ref="baseGraph" style="width: 100%; height: 500px; overflow: hidden;"></div>
	</div>
</template>
<script>
var echarts = require("echarts");
import { mapGetters } from "vuex";
import { GraphData } from "../../../mixins/baseReportGraphData";
import { EventBus } from "../../eventBus";

export default {
	name: "BaseReportGraph",
	mixins: [GraphData],
	data() {
		return {
			baseGraphInstance: ""
		};
	},
	computed: {
		...mapGetters(["getNameOfGraph"]),
	},
	watch: {
		getNameOfGraph(newValue, oldValue){
			// if(newValue){
			// }
		}
	},
	mounted() {
		this.initBaseGraph();

		EventBus.$on("getGraphDetails", data => {
			// console.log("data", data);
			if(data){
				this.map_graph_data(data);
			}else{
				this.clearGraph();
			}
		});
	},

	beforeDestroy() {
		EventBus.$off();
	},

	methods: {
		map_graph_data(graph_data) {
			this.graphSeries = [];
			this.graphXaxis.data = [];
			this.graphXaxis[0].axisLabel.rotate = 0;
			if (
				graph_data.reportsType == "wfr" &&
				graph_data.selectSalesView == "iplh"
			) {
				this.graphXaxis[0].axisLabel.rotate = 20;
				for (var key in graph_data.series) {
					// console.log('map_graph_data', graph_data.series[key], key);
					let obj = {
						name: "",
						type: "",
						data: ""
					};

					if (key == "forecastIplh") {
						obj.name = "Ideal IPLH";
						obj.type = "bar";
						obj.data = graph_data.series[key];
					} else if (key == "actualIplh") {
						obj.name = "Actual IPLH";
						obj.type = "bar";
						obj.data = graph_data.series[key];
					}
					this.graphSeries.unshift(obj);
					this.graphXaxis[0].axisLabel.interval = 0;
				}
			} else if (
				graph_data.reportsType == "wfr" &&
				graph_data.selectSalesView == "variance"
			) {
				this.graphXaxis[0].axisLabel.rotate = 20;
				for (var key in graph_data.series) {
					console.log('map_graph_data', key);
					let obj = {
						name: "",
						type: "",
						data: ""
					};
					if (key == "actualLabourHours") {
						obj.name = "Actual Labour Hours";
						obj.type = "bar";
						obj.data = graph_data.series[key];
					} else if (key == "forecastLabourHours") {
						obj.name = "Ideal Labour Hours";
						obj.type = "bar";
						obj.data = graph_data.series[key];
					} else if (key == "scheduledLabourHours") {
						obj.name = "Scheduled Labour Hours";
						obj.type = "bar";
						obj.data = graph_data.series[key];
					}
					if (key == "scheduledLabourHours") {
						this.graphSeries.splice(1,0,obj)
					} else {
						this.graphSeries.unshift(obj);
					}
					this.graphXaxis[0].axisLabel.interval = 0;
				}
			} else if (
				graph_data.reportsType == "wfr" &&
				graph_data.selectSalesView == "tplh"
			) {
				this.graphXaxis[0].axisLabel.rotate = 20;
				for (var key in graph_data.series) {
					// console.log('map_graph_data', graph_data.series[key]);
					let obj = {
						name: "",
						type: "",
						data: ""
					};

					if (key == "forecastTplh") {
						obj.name = "Ideal TPLH";
						obj.type = "bar";
						obj.data = graph_data.series[key];
					} else if (key == "actualTplh") {
						obj.name = "Actual TPLH";
						obj.type = "bar";
						obj.data = graph_data.series[key];
					}
					this.graphSeries.unshift(obj);
					this.graphXaxis[0].axisLabel.interval = 0;
				}
			} else if(graph_data.reportsType == "wfr" && graph_data.selectSalesView == "shift_complement"){
				this.graphXaxis[0].axisLabel.rotate = 20;
					let obj = {
						name: "",
						type: "",
						data: ""
					};

				obj.name = "Shift Complement";
				obj.type = "bar";
				obj.data = graph_data.series.shiftComplement;

			} else if (
				graph_data.reportsType == "sale" &&
				(graph_data.selectSalesView == "amt" || graph_data.selectSalesView == "adt" || graph_data.selectSalesView == "at" || graph_data.selectSalesView == "ipt")
			) {
				for (var key in graph_data.series) {
					// console.log('map_graph_data', graph_data.series[key]);
					let obj = {
						name: "",
						type: "",
						data: ""
					};

					if (key == "last_year") {
						obj.name = "Last Year";
						obj.type = "bar";
						obj.data = graph_data.series[key];
					} else if (key == "this_year") {
						obj.name = "This year";
						obj.type = "bar";
						obj.data = graph_data.series[key];
					}else if(key == 'target'){
						obj.name = "Forecast";
						obj.type = "bar";
						obj.data = graph_data.series[key];
					}

					this.graphSeries.push(obj);
					this.graphXaxis[0].axisLabel.interval = 0;
				}
			}else if ( (graph_data.reportsType == "day" || graph_data.reportsType == "week" || graph_data.reportsType == "month") && (graph_data.selectSalesView == "amt" || graph_data.selectSalesView == "adt" || graph_data.selectSalesView == "at" || graph_data.selectSalesView == "ipt") ) {
				let obj = {
						name: "",
						type: "",
						data: ""
					};

					obj.name = "";
					obj.type = "bar";
					obj.data = graph_data.series.consolidatedData;

					this.graphSeries.push(obj);
					this.graphXaxis[0].axisLabel.interval = null;
			}else {
				//for store data to line charts
				for (var i = 0; i < graph_data.series.storeData.length; i++) {
					// console.log('graph_data.series[i]', graph_data.series.storeData[i]);
					let obj = {
						name: graph_data.series.storeData[i].name,
						type: "line",
						data: graph_data.series.storeData[i].data,
						yAxisIndex: 1
					};
					this.graphSeries.push(obj);
					this.graphXaxis[0].axisLabel.interval = null;
				}
			}

			this.graphXaxis[0].data = graph_data.xAxisData;
			let graphName = "";
			if (graph_data.selectSalesView == "iplh") {
				graphName = "Items Per Labour Hour (IPLH)";
			} else if (graph_data.selectSalesView == "variance") {
				graphName = "Variance";
			} else if (graph_data.selectSalesView == "shift_complement") {
				graphName = "Shift Complement";
			} else if (graph_data.selectSalesView == "tplh") {
				graphName = "Transactions Per Labour Hour (TPLH)";
			} else if (graph_data.selectSalesView == "manpower") {
				graphName = "Manpower";
			} else if (graph_data.selectSalesView == "labour_hours") {
				graphName = "Labour Hours";
			}
			this.getNameOfGraph = graphName;
			this.reRenderGraph();
		},

		clearGraph: function() {
			this.baseGraphInstance.clear();
		},

		reRenderGraph: function() {
			this.clearGraph();
			this.baseGraphInstance.setOption(this.graphData);
			this.baseGraphInstance.hideLoading();
		},

		initBaseGraph() {
			let baseGraphContainer = this.$refs["baseGraph"];
			this.baseGraphInstance = echarts.init(
				baseGraphContainer,
				null,
				this.initOptions
			);
			this.baseGraphInstance.showLoading();
		}
	}
};
</script>
<style>
	tspan{
		text-transform: capitalize;
	}
</style>
